import { getReqCtx } from '../internal';
/**
 * 获取url查询参数
 * @returns
 */
export function getQuery() {
    const { query } = getReqCtx();
    return query || {};
}
/**
 * 根据name获取url查询参数值
 * @param name
 * @returns
 */
export function getQueryByName(name) {
    const query = getQuery();
    return (query === null || query === void 0 ? void 0 : query[name]) || '';
}
/**
 * 获取locaton 的 origin属性值
 * @returns
 */
export function getOrigin() {
    const { origin } = getReqCtx();
    return origin || '';
}
/**
 * 获取locaton 的 host属性值
 * @returns
 */
export function getHost() {
    const { host } = getReqCtx();
    return host || '';
}
/**
 * 获取locaton 的 pathname 属性值
 * @returns
 */
export function getPathname() {
    const { path } = getReqCtx();
    return path || '';
}
/**
 * 获取locaton 的 href 属性值
 * @returns
 */
export function getHref() {
    const { href } = getReqCtx();
    return href || '';
}
